export function truncateMetaText(value: string, maxLength: number): string {
  const normalized = value.replace(/\s+/g, " ").trim();
  if (normalized.length <= maxLength) return normalized;

  const candidate = normalized.slice(0, maxLength - 1);
  const lastSpace = candidate.lastIndexOf(" ");
  const truncated = candidate
    .slice(0, lastSpace > 0 ? lastSpace : undefined)
    .replace(/[,:;.!?\-]+$/, "");

  return `${truncated}…`;
}

/** Page title capped at 60 chars including the " | Matic" suffix. */
export function maticMetaTitle(title: string): string {
  const suffix = " | Matic";
  return `${truncateMetaText(title, 60 - suffix.length)}${suffix}`;
}
